import React from 'react';
import {GiftDisplay} from "./GiftDisplay";
import {inject, observer} from "mobx-react";
import UIStore from "../../../stores/UIStore";
import {EUnwrapStage} from "../../../models/UIModel";
import {Identify} from "./Identify";
import {UnwrapGift} from "./UnwrapGift";
import {UI} from "../../../UI";
import {PuzzleInfo} from "../../../../libs/PuzzleInfo";
import {RecipientInfo} from "../../../../libs/RecipientInfo";

// props for Unwrap component
interface IUnwrapProps {
    UI_STORE?:UIStore;
    match:any;
}

@inject('UI_STORE')
@observer
export class Unwrap extends React.Component<IUnwrapProps, any> {

    public constructor(props:IUnwrapProps) {
        super(props);
        this.initStage();
    }

    public render(): any {
        return (
            <>
                {this.getStageComponent()}
            </>
        );
    }

    public getStageComponent():any {

        switch (this.props.UI_STORE?.ui.stage) {
            case EUnwrapStage.Identify:
                return (<Identify></Identify>)
            case EUnwrapStage.Puzzle:
                return (
                    <UnwrapGift/>)
            case EUnwrapStage.Complete:
                return (<GiftDisplay/>)

        }
    }

    /**
     * Handler for when puzzle is complete
     */
    public onPuzzleComplete_Handler() {
        this.props.UI_STORE?.setStage(EUnwrapStage.Complete)
    }

    /**
     * Initialize the appropriate stage of the unwrapping process
     */
    public async initStage() {
        // get list of param keys
        let paramKeys:string[] = Object.keys(this.props.match.params);

        // if there are parameters
        if (paramKeys.length > 0) {
            // if in testing mode, no need to identify
            if (paramKeys.includes("puzzleId") == true) {

                // populate with dummy info
                RecipientInfo.buildTestAndPopulateUI();
                // pull puzzle info from api
                await PuzzleInfo.getRecordAndPopulate(parseInt(this.props.match.params["puzzleId"]));

                UI.UI_STORE.setStage(EUnwrapStage.Puzzle);
            }
            // else if auth code provided, need to identify
            else if (paramKeys.includes("code") == true) {

                await RecipientInfo.getRecordFromAuthCodeAndPopulateUI(this.props.match.params["code"])

                UI.UI_STORE.setStage(EUnwrapStage.Puzzle);
            }
        }
    }
}
